import React, { useEffect } from "react";
import "./header.css";
import logo from "../../../assets/iitr-logo.jpg";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const navItems = [
    { heading: "Home", path: "/" },
    { heading: "Publications", path: "/publications" },
    {
      heading: "Honors & Professional Background",
      path: "/honors&ProfessionalBackground",
    },
    { heading: "Teaching Engagements", path: "/teachingEngagement" },
    {
      heading: "Teammates & Collaborations",
      path: "/teammates&collaborations",
    },
    { heading: "Research Projects", path: "/researchProjects" },
    { heading: "Contact", path: "/contact" },
  ];

  const location = useLocation();

  useEffect(() => {
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  }, []);

  return (
    <div>
      <div className="institution-info">
        <img src={logo} alt="IIT Roorkee Logo" className="institution-logo" />
        <div className="institute-container">
          <h1 className="institute-name">
            Indian Institute of Technology Roorkee
          </h1>
          <h2 className="department-name">Civil Engineering Department</h2>
          <h4 className="group-name">Terrestrial Hydrology Group</h4>
        </div>
      </div>

      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid p-0">
          <button
            className="navbar-toggler mx-2"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasNavbar"
            aria-controls="offcanvasNavbar"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="offcanvas offcanvas-start"
            tabIndex="-1"
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
          >
            <div className="offcanvas-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div className="offcanvas-body">
              <ul className="navbar-nav">
                {navItems.map((item, index) => (
                  <li key={index} className="nav-item">
                    <Link
                      className={
                        location.pathname === item.path
                          ? "nav-link active p-0 fw-bold"
                          : "nav-link p-0"
                      }
                      to={item.path}
                    >
                      {item.heading}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav w-100 justify-content-around align-items-center">
              {navItems.map((item, index) => (
                <li key={index} className="nav-item">
                  <Link
                    className={
                      location.pathname === item.path
                        ? "nav-link active p-0 fw-bold text-center"
                        : "nav-link p-0 text-center"
                    }
                    to={item.path}
                  >
                    {item.heading}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Header;
